import { Spin } from "antd"
import { LoadingOutlined } from "@ant-design/icons"
import "./loading.scss"

const Loading = ({ className, position = "absolute", fontSize = 100 }) => {
  const classNames = [`loading-container${className ? " " + className : ""}`]
  if (position === "relative") {
    classNames.push("loading-position-relative")
  }

  return (
    <div className={classNames.join(" ")}>
      <Spin
        indicator={
          <LoadingOutlined
            style={{
              fontSize,
              color: "var(--prime-color-brand-bg-default)",
            }}
            spin
          />
        }
      />
    </div>
  )
}

export default Loading
